import { ApiProfileSimpleResponse } from '../api/types';
import { FileLoader } from '../lib/sj-orm/synchronizer/loaders/file-loader';

const fetchDatabase = async () => {
  const loader = new FileLoader();
  return loader.fetchDatabase();
};
// TODO rework, move myhub api into api
export const useApiMyhub = () => {
  const getCurrencyRate = async (baseCurrency: string, quoteCurrency: string) => {
    const db = await fetchDatabase();

    if (db?.currencyRates) {
      const rateData = db?.currencyRates.find((item) => {
        return item.baseCurrency === baseCurrency && item.quoteCurrency === quoteCurrency;
      });

      if (rateData) {
        return rateData.rate;
      }
    }

    return null;
  };

  const getProfile = async () => {
    const db = await fetchDatabase();
    return db?.profile ?? null;
  };

  const getScenarioList = async () => {
    const db = await fetchDatabase();
    return db?.scenarios ?? null;
  };

  const myhubGetSettings = async () => {
    const db = await fetchDatabase();
    return db?.settings ?? null;
  };

  // TODO just mock for myhub, we should not use beneficiaries on myhub
  const getProfileBeneficiaries = async () => {
    // return { data: [] as ApiProfileResponse[], error: null };
    return { data: [] as ApiProfileSimpleResponse[], error: null };
  };

  return {
    getCurrencyRate,
    getProfile,
    getScenarioList,
    myhubGetSettings,
    getProfileBeneficiaries,
  };
};
